/* eslint-disable */
// Portal configuration — colors, SVG patterns, metadata
// Shared across PortalSelection, SplashScreen (legacy interstitial removed Brief 3)

export const PORTALS = [
  {
    id: 'catalog', letter: 'C', name: 'ORIGINALS', subtitle: 'Products & Inventory',
    color: 'var(--sandstone)', dark: '#5e564e', light: '#b8b0a4',
    stats: [{ value: '1,566', label: 'Items' }, { value: '12', label: 'Brands' }],
    features: ['Full product catalog', 'Brand management', 'Image gallery', 'Advanced SKU search'],
    pattern: `<line x1="0" y1="50%" x2="100%" y2="50%" stroke="white" stroke-width=".5"/>
      <line x1="50%" y1="0" x2="50%" y2="100%" stroke="white" stroke-width=".5"/>
      <circle cx="50%" cy="50%" r="60" fill="none" stroke="white" stroke-width=".5"/>
      <circle cx="50%" cy="50%" r="30" fill="none" stroke="white" stroke-width=".8"/>
      <circle cx="25%" cy="30%" r="20" fill="none" stroke="white" stroke-width=".3"/>
      <circle cx="75%" cy="70%" r="25" fill="none" stroke="white" stroke-width=".3"/>
      <line x1="20%" y1="20%" x2="80%" y2="80%" stroke="white" stroke-width=".3"/>
      <rect x="35%" y="35%" width="30%" height="30%" fill="none" stroke="white" stroke-width=".3" rx="2"/>`,
  },
  {
    id: 'developments', letter: 'D', name: 'DEVELOPMENTS', subtitle: 'Design Pipeline',
    color: '#b8860b', dark: '#7a5a08', light: '#d4a838',
    stats: [{ value: '—', label: 'All-time' }, { value: '—', label: 'Designers' }],
    features: ['Visual stage pipeline', 'Sample round tracking', 'Drawing & photo uploads', 'Completion celebrations'],
    pattern: `<polygon points="130,30 170,110 90,110" fill="none" stroke="white" stroke-width=".5"/>
      <polygon points="130,50 155,95 105,95" fill="none" stroke="white" stroke-width=".8"/>
      <line x1="20" y1="140" x2="240" y2="140" stroke="white" stroke-width=".3"/>
      <circle cx="50" cy="140" r="4" fill="white" opacity=".4"/>
      <circle cx="100" cy="140" r="4" fill="white" opacity=".4"/>
      <circle cx="150" cy="140" r="4" fill="white" opacity=".4"/>
      <circle cx="200" cy="140" r="4" fill="white" opacity=".4"/>
      <line x1="30" y1="170" x2="230" y2="170" stroke="white" stroke-width=".2"/>
      <rect x="80" y="160" width="100" height="20" fill="none" stroke="white" stroke-width=".3" rx="2"/>`,
  },
  {
    id: 'qc', letter: 'Q', name: 'QC PORTAL', subtitle: 'Quality Control',
    color: '#2d6a4f', dark: '#1a3d2e', light: '#52b788',
    stats: [{ value: '8', label: 'Reports' }, { value: '3', label: 'Steps' }],
    features: ['3-step inspection wizard', 'Issue review & flagging', 'Rework follow-up', 'Auto-formatted reports'],
    pattern: `<circle cx="130" cy="90" r="50" fill="none" stroke="white" stroke-width=".5"/>
      <polyline points="105,90 125,110 158,72" fill="none" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
      <circle cx="130" cy="90" r="70" fill="none" stroke="white" stroke-width=".25" stroke-dasharray="4,6"/>
      <line x1="40" y1="170" x2="220" y2="170" stroke="white" stroke-width=".3"/>
      <rect x="40" y="175" width="60" height="6" fill="white" opacity=".15" rx="1"/>
      <rect x="110" y="175" width="60" height="6" fill="white" opacity=".1" rx="1"/>
      <rect x="180" y="175" width="40" height="6" fill="white" opacity=".08" rx="1"/>`,
  },
  {
    id: 'sales', letter: 'S', name: 'SALES PORTAL', subtitle: 'Analytics & Reports',
    color: 'var(--burgundy)', dark: '#4a1822', light: '#a85a6a',
    stats: [{ value: '—', label: 'Items with sales' }, { value: '—', label: 'Latest batch', type: 'text' }],
    features: ['Batch upload & analysis', 'Dashboard & KPIs', 'Model family breakdown', 'PDF & Excel reports'],
    pattern: `<line x1="40" y1="180" x2="40" y2="60" stroke="white" stroke-width=".5"/>
      <line x1="40" y1="180" x2="220" y2="180" stroke="white" stroke-width=".5"/>
      <polyline points="50,150 90,130 130,110 170,80 210,50" fill="none" stroke="white" stroke-width="1.2"/>
      <circle cx="50" cy="150" r="3" fill="white"/>
      <circle cx="90" cy="130" r="3" fill="white"/>
      <circle cx="130" cy="110" r="3" fill="white"/>
      <circle cx="170" cy="80" r="3" fill="white"/>
      <circle cx="210" cy="50" r="3" fill="white"/>
      <rect x="60" y="155" width="12" height="20" fill="white" opacity=".2"/>
      <rect x="100" y="140" width="12" height="35" fill="white" opacity=".2"/>
      <rect x="140" y="120" width="12" height="55" fill="white" opacity=".2"/>
      <rect x="180" y="90" width="12" height="85" fill="white" opacity=".2"/>`,
  },
];

export const PORTAL_TAB_MAP = {
  catalog: 'catalog',
  developments: 'developments',
  qc: 'qc',
  sales: 'sales_portal',
  // Brief 2 — Projects portal shell. Header nav navigates via the subsection's
  // tab; this mapping lets the landing/splash path resolve 'projects' too.
  projects: 'projects',
  // Orders Phase 1 — same reason: without the mapping the hub/splash lookup falls
  // back to 'catalog' and routes Orders clicks to the wrong tab.
  orders: 'orders',
  // CLB-069 — the Collection-only role's own tab (the Wall, read-only); not an Orders world.
  collection: 'collection',
  // MAIL-1 — the super-admin Mail portal (gated at every entry, see src/portals/mail/mailGate.js).
  mail: 'mail',
};

export function getPortalById(id) {
  return PORTALS.find(p => p.id === id);
}
